import { Button, Select, Spin } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
//TODO finish it
export const StyledButton = styled(Button)`
  margin: 0;
  font-family: inherit;
  overflow: visible;
  text-transform: uppercase;
  display: inline-block;
  color: #00003c;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-weight: 700;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  :hover {
    color: #212529;
    text-decoration: none;
  }

  :focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 0, 60, 0.25);
  }

  :disabled {
    opacity: 0.65;
  }

  :focus:not(:focus-visible) {
    outline: 0;
  }

  padding: 0 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
`;

export const StyledLink = styled(Link)`
  margin: 0;
  font-family: inherit;
  overflow: visible;
  text-transform: uppercase;
  display: inline-block;
  color: #00003c;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-weight: 700;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  :hover {
    color: #212529;
    text-decoration: none;
  }

  :focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 0, 60, 0.25);
  }

  :disabled {
    opacity: 0.65;
  }

  :focus:not(:focus-visible) {
    outline: 0;
  }

  padding: 0 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
`;

export const Loader = styled(Spin)`
  width: 100%;

  i {
    background-color: ${(p) => p.theme.details};
  }
`;

export const StyledTableFilterSelect = styled(Select)`
  min-width: 115px;
  text-align: right;
`;
